import React from 'react';

const Section = ({ title, add, children }) => (
    <div className="mb-4">
        <h5 className="mb-3 text-primary text-start w-100">
            {title} &nbsp;
            {add && <i className="bi bi-plus-circle fs-4" onClick={add}></i>}
        </h5>
        <div className="row g-3">
            {children}
        </div>
    </div>
);

export default Section;